export var StatusVariant;
(function (StatusVariant) {
    StatusVariant["CREATED"] = "created";
    StatusVariant["INPROGRESS"] = "inProgress";
    StatusVariant["DELAY"] = "delay";
    StatusVariant["SHIPPED"] = "shipped";
    StatusVariant["CANCELED"] = "canceled";
    StatusVariant["EXPIRED"] = "expired";
})(StatusVariant || (StatusVariant = {}));
//# sourceMappingURL=TagStatus.types.js.map